/* eslint-disable no-param-reassign */
import { MODES } from "../misc/constants";

const getDefaultMode = () => document.getElementById("order-number-container")?.dataset?.pageMode;

const MADE_MODES = {
  PRINT_DEFAULT: "print_default",
  PRINT_FRONT_BACK: "print_front_back"
};

const initialState = {
  mode: getDefaultMode() || MODES.BLANKS,
  supportsMade: false,
  filledSizes: [],
  madeMode: MADE_MODES.PRINT_DEFAULT,
  activeColor: "",
  compositionId: null
};

const appModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    mode: state => state.mode,
    madeMode: state => state.madeMode,
    activeColor: state => state.activeColor,
    supportsMade: state => state.supportsMade,
    filledSizes: state => state.filledSizes
  },

  mutations: {
    setMode(state, mode) {
      state.mode = mode;
    },
    setMadeMode(state, madeMode) {
      state.madeMode = madeMode;
    },
    setSupportsMade(state, supportsMade) {
      state.supportsMade = supportsMade;
    },
    setActiveColor(state, color) {
      state.activeColor = color;
    },
    setFilledSizes(state, sizes) {
      state.filledSizes = sizes;
    }
  },

  actions: {
    setMode({ commit }, mode) {
      commit("setMode", mode);
    },
    setActiveComposition({ commit }, { compositionId, color }) {
      commit("setActiveColor", color);

      const numId = Number(compositionId);
      if (Number.isNaN(numId)) throw new Error(`Invalid compositionId: ${compositionId}`);
      commit("product/setCompositionId", numId, { root: true });
    }
  }
};

export default appModule;
